import Rete from 'rete';
import LabelNumberText from "./components/LabelNumberText";

export class LabelNumberTextControl extends Rete.Control {

    static get DEFAULT_VALUE() { return 0; };

    constructor(editor, key, node, readonly = false, labelText, inputDisabled = false, allowDecimal = false) {
        super(key);
        // this.render = 'react'; // required?
        this.key = key;
        this.component = props => (
            <LabelNumberText {...props} />
        );

        const initial = node.data[key] || LabelNumberTextControl.DEFAULT_VALUE;
        node.data[key] = initial;

        this.props = {
            readonly,
            editor,
            value: initial,
            // putData: (key: string, data: unknown) => this.putData(key, data),
            putData: (data) => this.putData(this.key, data),
            labelText: labelText,
            allowDecimal: allowDecimal,
            inputDisabled: inputDisabled,
        };
    }
}